export const CREATEUSER = 'CREATEUSER';
export const CREATEUSER_SUCCESS = 'CREATEUSER_SUCCESS';
export const CREATEUSER_ERROR = 'CREATEUSER_ERROR';
export const GETUSER = 'GETUSER';
export const GETUSER_SUCCESS = 'GETUSER_SUCCESS';
export const GETUSER_ERROR = 'GETUSER_ERROR';
export const USER_READ_CGU = 'USER_READ_CGU';
export const USER_READ_CGU_ERROR = 'USER_READ_CGU_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const HAS_UNREAD_JOURNALIST_MESSAGE = 'HAS_UNREAD_JOURNALIST_MESSAGE';


// WEBPACK FOOTER //
// ./src/components/user/userActionTypes.js